import React, {Component} from 'react';
import { BarLoader } from 'react-spinners';
import ThemaDetail from './ThemaDetail'
import ThemenPaginator from './ThemenPaginator'
import Reset from "../components/Reset"

class Themen extends Component {
    render() {

        if (this.props.themen.list.length === 0) {
            return <div className={'row'}>
                <div className={'col-md-12'}>
                    <BarLoader/>
                </div>
            </div>
        }

        if (this.props.themen.isFetching) {
            return <div className={'row'}>
                <div className={'col-md-12'}>
                    <BarLoader/>
                </div>
            </div>
        }

        if (this.props.themen.list.data.length === 0) {
            return <div className={'row'}>
                <div className={'col-md-6'}>
                    Keine Themen gefunden
                </div>
                <div className={'col-sm-6'}>
                    <Reset resetFilter={this.resetFilter.bind(this)}/>
                </div>
                <hr />
            </div>
        }

        return <div>
            <div>
                <div className={'row'}>
                    <div className={'col-sm-6'}>
                        <h1><strong>{this.props.themen.list.total}</strong> Themen gefunden</h1>
                    </div>
                    <div className={'col-sm-6'}>
                        <Reset resetFilter={this.resetFilter.bind(this)}/>
                    </div>
                    <hr />
                </div>
            </div>
            <ul className={'list-group'} id={'themen'}>
                {
                    this.props.themen.list.data.map(
                        thema => <ThemaDetail key={thema.id+Math.random()*5} thema={thema} selected={this.props.selected} selectThema={this.props.selectThema.bind(this)} referenten={this.props.referenten} />
                    )
                }
            </ul>
            <ThemenPaginator themen={this.props.themen} appendThemenNextPage={this.props.appendThemenNextPage} themenAdding={this.props.themenAdding} />
        </div>
    }

    resetFilter() {
        window.location.reload();
    }
}

export default Themen




// WEBPACK FOOTER //
// ./src/components/Themen.js